"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const resolveImage = (subFormats, tag) => {
  return subFormats.filter(image => {
    return image.formatTag === tag || image.formatIdentifier === tag;
  });
};
var _default = exports.default = resolveImage;